var map = {
	"./candidate.js": "ynKR",
	"./customer.js": "Z7rG",
	"./finance.js": "OXQ6",
	"./global.js": "VssV",
	"./operation.js": "Um2R",
	"./position.js": "liiB",
	"./reports.js": "O/Rr",
	"./user.js": "eB4u",
	"./workbench.js": "kU+T"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "foaR";